<template>
    <vx-card no-shadow class="mb-8" :title="$t('my_interests')">
        <div class="vx-col w-full">
            <div class="mb-2" v-for="(item, index) in interests" :key="index">
                <div class="flex">
                    <!-- Описание интереса -->
                    <vs-textarea
                        v-validate="'required'"
                        :placeholder="$t('description')"
                        class="w-full mb-0"
                        :disabled="true"
                        :name="`i_t_${ item.key }`"
                        v-model="item.content" />

                    <!-- Кнопка удалить интерес -->
<!--                    <vs-button-->
<!--                        v-if="interests.length > 1"-->
<!--                        color="red"-->
<!--                        class="ml-2"-->
<!--                        @click="deleteItem(item)"-->
<!--                        type="border"-->
<!--                        icon-pack="feather"-->
<!--                        icon="icon-trash">-->
<!--                    </vs-button>-->
                </div>

                <span class="text-danger w-full text-sm" v-show="errors.has(`i_t_${ item.key }`)">{{ $t('validation_required') }}</span>
            </div>
<!--            <div class="mb_reverse lg:flex mt-4">-->
<!--                &lt;!&ndash; Кнопка сохранить &ndash;&gt;-->
<!--                <vs-button class="edit_interests_btn lg:mr-3 edt_btn" color="primary" @click="formSubmit()" icon-pack="feather" icon="icon-save" type="filled">{{$t('save')}}</vs-button>-->

<!--                &lt;!&ndash; Кнопка добавить интерес &ndash;&gt;-->
<!--                <vs-button @click="add()" class="edit_btn edt_btn" color="primary" type="border" icon-pack="feather" icon="icon-plus">{{$t('add_interest')}}</vs-button>-->
<!--            </div>-->
        </div>
    </vx-card>
</template>

<script>
export default {
    props: {
        userData: Object
    },
    data() {
        return {
            listDeleted: [],
            interests: []
        }
    },
    created: function() {
        this.generate()
    },
    methods: {
        generate() {
            // Генерируем форму из данных о пользователе по интересам
            if(this.userData.interests.length) {
                this.userData.interests.forEach((item, index) => {
                    this.interests.push({
                        content: item.content,
                        key: index,
                        uid: item.uid
                    })
                })
            } else {
                this.interests = [
                    {
                        content: '',
                        key: Date.now()
                    }
                ]
            }
        },
        add() {
            // Добавить новый интерес
            this.interests.push({
                content: '',
                key: Date.now()
            })
        },
        deleteItem(elem) {
            // Удалить интерес
            const index = this.interests.findIndex(item => item.key === elem.key)
            this.interests.splice(index, 1)

            if(elem.uid)
                this.listDeleted.push(elem.uid)

            if(!this.interests.length)
                this.add()
        },
        formSubmit() {
            // Сохраняем/обновляем интерес
            this.$validator.validateAll().then(async result => {
                if(result) {
                    try {
                        this.$vs.loading({
                            container: '.edit_interests_btn',
                            scale: 0.45
                        })

                        const {data} = await this.$http.put(`/user/profile/${ this.userData.profileId }/interests/edit/`, {
                            interests: this.interests,
                            interests_for_del: this.listDeleted
                        })
                    } catch(e) {
                        this.$vs.notify({
                            text: this.$t('error'),
                            color: 'danger',
                        })
                    } finally {
                        this.$vs.loading.close('.edit_interests_btn > .con-vs-loading')
                        this.$vs.notify({
                            text: this.$t('data_saved'),
                            color: 'success',
                        })
                    }
                }
            })
        }
    }
}
</script>

<style lang="scss">
.edit_interests_btn{
    position: relative;
    .con-vs-loading{
        position: absolute;
    }
}
</style>
